var exports = {
  "kL": "x31de4314--40e897--container",
  "yJ": "x31de4314--40e897--links",
  "PD": "x31de4314--40e897--links--expanded",
  "UI": "x31de4314--40e897--links-block",
  "hJ": "x31de4314--40e897--counter",
  "nf": "x31de4314--40e897--link",
};

module.exports = exports;
